/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import "./src/styles/tailwind.css"
import { getLangAttribute } from "./src/constants/locale.constants"
import { runtimeConfig } from "./src/constants/runtimeConfig.constants"
import { HEADER_HEIGHT } from "./src/components/Globals/Header/Header.constants"

const onRouteUpdate = ({ location, prevLocation }) => {
    const { pathname, search, hash } = location
    const prevPathname = prevLocation?.pathname

    document.documentElement.lang = getLangAttribute(pathname)

    if (pathname.includes("/index.html")) {
        const newPathname = pathname.replace("/index.html", "/")
        window.location.href = newPathname + search + hash
    }

    if (pathname === prevPathname) {
        return
    }

    if (hash) {
        const sanitizeHash = hash => hash.replace(/^#/, "").replace(/\/+$/, "")
        const hashId = sanitizeHash(hash)
        if (!hashId) return
        const el = document.querySelector(`[data-scroll-id="${hashId}"]`)
        if (!el) {
            console.log(`Element with ID "${hashId}" not found.`)
            return
        }
        if (el) {
            const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_HEIGHT
            window.scrollTo({ top: y, behavior: "smooth" })
        }
    }
}

const onClientEntry = () => {
    if (typeof window !== "undefined" && !window.__RUNTIME_CONFIG__) {
        window.__RUNTIME_CONFIG__ = runtimeConfig
    }
}

export { onRouteUpdate, onClientEntry }
